import { createApp } from 'vue';
import DngToWebpConverter from '../Components/DngToWebpConverter.vue';

const root = document.getElementById('dng-to-webp-converter');
if (root) {
  createApp(DngToWebpConverter).mount('#dng-to-webp-converter');
}
